export default __webpack_public_path__ + "static/media/face-5.e725aef8.jpeg";